import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { apiRequest } from './apiClient';
import './auth.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function LoginPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { refresh } = useAuth();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [info, setInfo] = useState(searchParams.get('msg') || null);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(null); setInfo(null);
    setSubmitting(true);
    try {
      const { ok, data } = await apiRequest('POST', `${BACKEND_URL}/api/auth/login`, {
        body: { email, password },
      });
      if (!ok) {
        setError(typeof data.detail === 'string' ? data.detail : 'Login failed.');
        return;
      }
      await refresh();
      const next = searchParams.get('next') || '/';
      navigate(next, { replace: true });
    } catch (err) {
      setError('Network error: ' + err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card" data-testid="login-card">
        <div className="auth-brand"><span className="auth-brand-dot"></span> Estatel AI</div>
        <h1 className="auth-title">Sign in</h1>
        <p className="auth-subtitle">Welcome back. Sign in to your Estatel AI account.</p>
        {info && <div className="auth-success" data-testid="login-info">{info}</div>}
        {error && <div className="auth-error" data-testid="login-error">{error}</div>}
        <form onSubmit={submit}>
          <div className="auth-field">
            <label htmlFor="login-email">Email address</label>
            <input id="login-email" type="email" value={email} onChange={e => setEmail(e.target.value)} required autoComplete="email" data-testid="login-email" />
          </div>
          <div className="auth-field">
            <label htmlFor="login-password">Password</label>
            <input id="login-password" type="password" value={password} onChange={e => setPassword(e.target.value)} required autoComplete="current-password" data-testid="login-password" />
          </div>
          <button
            type="submit"
            disabled={submitting}
            style={{
              width: '100%', background: submitting ? '#94a3b8' : '#0073EA', color: '#fff',
              border: 'none', borderRadius: 6, padding: '0.7rem', fontSize: '0.95rem',
              fontWeight: 500, cursor: submitting ? 'not-allowed' : 'pointer', marginTop: '0.5rem',
            }}
            data-testid="login-submit"
          >
            {submitting ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
        <div className="auth-footer">
          <div style={{ marginBottom: '0.5rem' }}><Link to="/forgot-password" data-testid="login-forgot-link">Forgot password?</Link></div>
          <div>Don't have an account? <Link to="/signup" data-testid="login-signup-link">Create one</Link></div>
        </div>
      </div>
    </div>
  );
}
